import React, { useState, useRef, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Seccion from 'components/Modificaciones/Seccion'
import TopHeader from 'components/TopHeader'

function Inicio() {

	// render
	return (
		<Container fluid id="seccion2-1" className="vh-100">
			<TopHeader
				iconName="window-restore"
				text="Modificaciones sección Inicio"
			/>
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Seccion
						nombreSeccion="inicio"
					/>
				</Col>
			</Row>
		</Container>
	)
}

export default Inicio